import {
  AmendableAppointmentStrategy,
  AmendedAppointmentStrategy,
  BookedAppointmentStrategy,
  DefaultAppointmentStrategy,
  ExpertSetupAppointmentStrategy,
  Kci2AssureAppointmentStrategy,
  MissedAppointmentStrategy,
} from './strategies/appointment';
import { AppointmentStrategy } from './strategies/appointment/AppointmentStrategy';

export const INVALID_POSTCODE: string = '605 (Invalid Postcode)';

export const ORDER_STATUS_IN_PROGRESS: string = 'In Progress';
export const ORDER_STATUS_DELAYED: string = 'Delayed';
export const ORDER_STATUS_COMPLETED: string = 'Completed';
export const ORDER_STATUS_CANCELLED: string = 'Cancelled';
export const ORDER_STATUS_PARTIALLY_CANCELLED: string = 'Partially Cancelled';
export const ORDER_STATUS_CANCELLATION_IN_PROGRESS: string = 'Cancellation In Progress';
export const ORDER_STATUS_AWAITING_CREDIT_CHECK: string = 'Awaiting Credit Check';
export const ORDER_STATUS_COMMITTED: string = 'Committed';
export const ORDER_STATUS_PROVISIONING: string = 'Provisioning';
export const ORDER_STATUS_AWAITING_ECC: string = 'Awaiting ECC';

export const AVAILABLE_ORDER_STATUSES: string[] = [
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_PROVISIONING,
  ORDER_STATUS_COMMITTED,
  ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_DELAYED,
  ORDER_STATUS_AWAITING_ECC,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_CANCELLATION_IN_PROGRESS,
  ORDER_STATUS_AWAITING_CREDIT_CHECK,
];

export const INVALID_DATE: string = 'Invalid Date';
export const MAX_ITEMS_IN_POP_UP: number = 3;

export const GROUP_PRODUCT_REFERENCE: string = 'GB';

export const BUNDLE_PRODUCT_TYPE: number = 8;

export const EXPERT_SETUP_APPOINTMENT_TYPE: number = 10;

export const PAGE_TYPE: Record<string, string> = {
  entryPage: 'Enter your details',
  orderSummary: 'Order summary',
  summaryError: 'Summary error',
  waitingRoom: 'We are loading your order',
  error: 'Error State',
};

export const CONTENT_FRAGMENT_TYPE: string = 'content-service/components/content/contentfragment';

export const CONTENT_FRAGMENT_ORDER_TRACKER_SUMMARY: string = 'content-service/models/order-tracker-summary';
export const CONTENT_FRAGMENT_ENTRY_LIVECHAT: string = 'content-service/models/livechat-footer';
export const CONTENT_FRAGMENT_HERO_BANNER: string = 'content-service/models/order-tracker-hero-banner';
export const CONTENT_FRAGMENT_ENTRY_FORM: string = 'content-service/models/order-tracker-entry-form';
export const CONTENT_FRAGMENT_MOBILE_APP_TEASER: string = 'content-service/models/mobile-app-teaser';

export const mapAEMContentFragmentModelToShortName: Map<string, string> = new Map([
  [CONTENT_FRAGMENT_ORDER_TRACKER_SUMMARY, 'orderTrackerSummaryProps'],
  [CONTENT_FRAGMENT_ENTRY_FORM, 'entryFormProps'],
  [CONTENT_FRAGMENT_HERO_BANNER, 'heroBannerProps'],
  [CONTENT_FRAGMENT_MOBILE_APP_TEASER, 'mobileAppTeaserProps'],
  [CONTENT_FRAGMENT_ENTRY_LIVECHAT, 'entryLiveChatProps'],
]);

export const singleOrderStatusPriority: string[] = [
  ORDER_STATUS_AWAITING_CREDIT_CHECK,
  ORDER_STATUS_CANCELLATION_IN_PROGRESS,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_AWAITING_ECC,
  ORDER_STATUS_DELAYED,
  ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_COMMITTED,
  ORDER_STATUS_PROVISIONING,
  ORDER_STATUS_COMPLETED,
];

export const arrivedWithYouEventCodes: string[] = [
  'EVCAD',
  'EVNPO',
  'EVKSP',
  'EVYCC',
  'EVCAS',
  'EVNSC',
  'EVNCE',
  'EVYCE',
  'EVCFS',
  'EVPLC',
  'EVNCM',
  'EVYCF',
  'EVDEL',
  'EVPLF',
  'EVNCO',
  'EVYCL',
  'EVKDN',
  'EVVCC',
  'EVNCP',
  'EVYCO',
  'EVKNS',
  'EVVCL',
  'EVNFS',
  'EVYCP',
  'EVKOP',
  'EVVDD',
  'EVNLP',
  'EVYDD',
  'EVKSF',
  'EVVDN',
  'EVNOC',
  'EVYDN',
];

export const slotAMPMProperties: string[] = ['HasAM', 'HasPM'];
export const slotTwoHoursProperties: string[] = ['HasAS1000', 'HasAS1200', 'HasAS1400', 'HasAS1600', 'HasAS1800', 'HasAS2000'];
export const slotTwoHoursAltProperties: string[] = ['HasAS0900', 'HasAS1100', 'HasAS1300', 'HasAS1500', 'HasAS1700', 'HasAS1900'];

export const mapSlotsPropertiesBySlotsType: Record<string, string[]> = {
  'AM/PM': slotAMPMProperties,
  TwoHour: slotTwoHoursProperties,
  TwoHourAlt: slotTwoHoursAltProperties,
  TwoHourMix: [...slotTwoHoursProperties, ...slotTwoHoursAltProperties].sort(),
};

export const mapSlotsValueBySlotsName: Record<string, string> = {
  HasAM: '08:00-13:00',
  HasPM: '13:00-18:00',
  HasAS1000: '08:00-10:00',
  HasAS1200: '10:00-12:00',
  HasAS1400: '12:00-14:00',
  HasAS1600: '14:00-16:00',
  HasAS1800: '16:00-18:00',
  HasAS2000: '18:00-20:00',
  HasAS0900: '07:00-09:00',
  HasAS1100: '09:00-11:00',
  HasAS1300: '11:00-13:00',
  HasAS1500: '13:00-15:00',
  HasAS1700: '15:00-17:00',
  HasAS1900: '17:00-19:00',
};

export const MAX_DAYS_NUMBER_FOR_AMPM_SLOTS: number = 5;
export const MAX_DAYS_NUMBER_FOR_TWOHOURS_SLOTS: number = 3;
export const MAX_DAYS_NUMBER_FOR_MIXED_SLOTS: number = 1;

export const appointmentStrategies: AppointmentStrategy[] = [
  new AmendedAppointmentStrategy(),
  new MissedAppointmentStrategy(),
  new ExpertSetupAppointmentStrategy(),
  new Kci2AssureAppointmentStrategy(),
  new BookedAppointmentStrategy(),
  new AmendableAppointmentStrategy(),
  new DefaultAppointmentStrategy(),
];

export const YOUR_APPOINTMENTS: string = 'Your appointments';

export const TITLE_NAMES_MAPPER: Record<string, string> = {
  'Expert set up appointment': 'Expert Setup',
  'Openreach engineer appointment': 'Engineer visit',
};

export const MILESTONES_NAMES_MAPPER: Record<string, string> = {
  'Openreach engineer appointment': 'Engineer visit',
  'Expert set up appointment': 'Expert Setup',
};
